import { forwardRef } from "react";

/**
 * Primary CTA — pill button with rainbow gradient BORDER (not full fill).
 * Inner is a solid surface so text stays readable.
 */
export const RainbowButton = forwardRef(function RainbowButton(
  { as: Comp = "button", className = "", inner = "", children, ...props },
  ref
) {
  return (
    <Comp
      ref={ref}
      className={`relative inline-flex h-12 items-center justify-center rounded-full p-[1.5px] rainbow-border overflow-hidden group ${className}`}
      {...props}
    >
      <span
        className={`flex h-full w-full items-center justify-center rounded-full bg-background px-6 text-sm font-medium text-foreground transition-colors group-hover:bg-transparent group-hover:text-white ${inner}`}
      >
        {children}
      </span>
    </Comp>
  );
});

/** Solid primary — high contrast pill */
export const PillButton = forwardRef(function PillButton(
  { as: Comp = "button", variant = "primary", className = "", children, ...props },
  ref
) {
  const styles = {
    primary:
      "bg-foreground text-background hover:bg-foreground/90 active:scale-[0.98]",
    ghost:
      "bg-transparent text-foreground border border-border hover:bg-foreground/5 active:scale-[0.98]",
    subtle:
      "bg-foreground/5 text-foreground hover:bg-foreground/10 active:scale-[0.98] border border-border",
  };
  return (
    <Comp
      ref={ref}
      className={`inline-flex h-11 items-center justify-center rounded-full px-6 text-sm font-medium transition-all duration-200 ${styles[variant]} ${className}`}
      {...props}
    >
      {children}
    </Comp>
  );
});
